import { seoPack } from "./seo-content";
import type { Locale } from "@/i18n/locales";
import type { HotTopic } from "./hot-cluster";

/** Localised copy only. Slugs, boards, keywords and related links stay English-defined. */
export type HotTopicTranslation = {
  h1?: string;
  title?: string;
  description?: string;
  intro?: string;
  sections?: { h2: string; body: string[] }[];
  faq?: [string, string][];
};

export type HotTopicLocalePack = Partial<Record<string, HotTopicTranslation>>;


export type HotTopicContent = Pick<
  HotTopic,
  "h1" | "title" | "description" | "intro" | "sections" | "faq"
>;

export function getHotClusterContent(locale: Locale, topic: HotTopic): HotTopicContent {
  const t = locale === "en" ? undefined : seoPack(locale)?.hotTopics?.[topic.slug];
  return {
    h1: t?.h1 ?? topic.h1,
    title: t?.title ?? topic.title,
    description: t?.description ?? topic.description,
    intro: t?.intro ?? topic.intro,
    sections:
      t?.sections?.length === topic.sections.length ? t.sections! : topic.sections,
    faq: t?.faq?.length === topic.faq.length ? t.faq! : topic.faq,
  };
}
